import { ModelDataType } from 'src/app/interfaces/model-data-type';
import { QuickSourceProgressName } from 'src/app/interfaces/quick-source-progress-name';

import { BaseModel } from './base-model';
import { ProposalRequest } from './proposal-request';

export class QuickSourceProgress extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static QuickSourceProgressProperties: (
    | {
        property: keyof QuickSourceProgress;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof QuickSourceProgress;
        type: 'alias';
      }
    | {
        property: keyof QuickSourceProgress;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'ProposalRequestId', type: 'column', dataType: 'number' },
    { property: 'name', type: 'column', dataType: 'string' },
    { property: 'status', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    {
      property: 'ProposalRequest',
      model: 'ProposalRequest',
      type: 'association'
    }
  ];

  static {
    QuickSourceProgress.QuickSourceProgressProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          QuickSourceProgress.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          QuickSourceProgress.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          QuickSourceProgress.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(QuickSourceProgressObject: Partial<QuickSourceProgress>) {
    super();

    QuickSourceProgress.QuickSourceProgressProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = QuickSourceProgressObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  ProposalRequestId?: number;
  name?: QuickSourceProgressName;
  status?: 'Started' | 'Complete' | null;
  createdAt?: Date;
  updatedAt?: Date;

  ProposalRequest?: ProposalRequest;
}
